export default __webpack_public_path__ + "components/weather-icon/static/nightrainshowers@3-6e616f6ec64acebe1a4b6ff5199bb756.png";